import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";

export const FileNameDialog = ({
  openFileNamePopup,
  onCLoseDialog,
  exportData,
}) => {
  const [fileName, setFileName] = useState("");

  const handleFileNameChange = (event) => {
    setFileName(event.target.value);
  };

  return (
    <Dialog
      open={openFileNamePopup}
      onClose={() => onCLoseDialog(false)}
      fullWidth={true}
      maxWidth={"xs"}
    >
      <DialogTitle>File Name</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="fileName"
          label="Enter File Name"
          type="text"
          fullWidth
          value={fileName}
          onChange={handleFileNameChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCLoseDialog(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={() => exportData(fileName)} color="primary">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
